import { render } from "./ForgotPasswordComp.vue?vue&type=template&id=d65dc188&scoped=true"
import script from "./ForgotPasswordComp.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordComp.vue?vue&type=script&lang=js"

import "./ForgotPasswordComp.vue?vue&type=style&index=0&id=d65dc188&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65dc188"]])

export default __exports__